/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BUCKET_CONFIG_TYPE, ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE, RIS_TYPE, TOAST_TYPES, VODTYPE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { Description, Title } from "@mui/icons-material";
import ToastNotification from "../../components/ToastNotification";


export const ImageGroupEditForm = (props) => {
  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Name: props.item.copy ? 'copy of ' + props.item.Name : props.item.Name ?? '',
    IsDefault: props.item.IsDefault ?? false,
    Archive: props.item.Archive ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  useEffect(() => {
  }, [])


  //function to check the validation in form
  const isValid = () => {
    if (!dataItem.Name || dataItem.Name == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
      return false;
    }

    return true;
  }

  const handleSubmit = async (e) => {

    if (!isValid()) return;
    const saveData = {
      _id: dataItem._id,
      SID: dataItem.SID ?? 0,
      Name: dataItem.Name,
      IsDefault: dataItem.IsDefault ?? false,
      Archive: dataItem.Archive ?? false,
    }
    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.ImageGroups, saveData);
    if (res.success) {
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.IMAGE_GROUPS, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.ImageGroups);
      props.cancelEdit();
      props.refresh();
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onChangeForm = (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else if (e.target.name == "IsDefault") {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  };


  
  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Name : "Create Image Group"}
      onClose={props.cancelEdit}
      width={"420px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <div className="row mt-2 form-group">
        <div className="col">
          <label>{lang.name_label} *</label>
          <input
            name={"Name"}
            type="text"
            className="form-control form-control-sm"
            onChange={onChangeForm}
            value={dataItem.Name}
          />
        </div>
      </div>
      <div className="row form-group">
        <div className="col-6" >
          <input type={"checkbox"} name={"IsDefault"}
            onChange={(e) => onChangeForm(e)}
            value={dataItem.IsDefault}
            checked={dataItem.IsDefault} />
          <label className="ml-1">{lang.is_default_label}</label>
        </div>
        <div className="col" >
          <input type={"checkbox"} name={"Archive"}
            onChange={(e) => onChangeForm(e)}
            value={dataItem.Archive}
            checked={dataItem.Archive} />
          <label className="ml-1">{lang.archive}</label>
        </div>
      </div>
    
    </BossDialog>)
};